import React from 'react';
import { Layout, Row, Col } from 'antd';
import classNames from 'classnames';

import Column, { FooterColumn } from './Column';
import { FooterContentItem } from './Content';
import { renderFestivalClassName } from '@utils/.';
import Bottom, { BottomItem } from './Bottom';

require('./index.less');

const { Footer } = Layout;

export type FooterProps = {
  prefixCls?: string;
  bottom?: { title?: string; items: BottomItem[] };
  logo?: React.ReactNode;
  maxColumnsPerRow?: number;
  columns?: FooterColumn[];
  contentItems?: FooterContentItem[];
  className?: string;
  style?: React.CSSProperties;
  backgroundColor?: string;
  columnLayout?: 'space-around' | 'space-between';
  festival?: string;
};

const GlobalFooter = ({
  prefixCls = 'rc-footer',
  className,
  style,
  backgroundColor,
  bottom,
  columns,
  maxColumnsPerRow,
  columnLayout,
  festival,
  ...restProps
}: FooterProps) => {
  const footerClassName = classNames(`${prefixCls}`, className);
  const shouldWrap = typeof maxColumnsPerRow === 'number' && maxColumnsPerRow > 0;

  return (
    <Footer
      {...restProps}
      className={footerClassName}
      style={{
        ...style,
        backgroundColor,
      }}
    >
      <section
        className={classNames(
          `${prefixCls}-container`,
          renderFestivalClassName(festival || '', { chrismas: `${prefixCls}-chrismas`, tet: `${prefixCls}-tet` }),
        )}
      >
        <Row className={`${prefixCls}-rowFooter`}>
          <Col span={24}>
            {columns && columns.length > 0 && (
              <section
                className={`${prefixCls}-columns`}
                style={{
                  justifyContent: columnLayout,
                  flexWrap: shouldWrap ? 'wrap' : undefined,
                }}
              >
                {columns.map(({ title, icon, style: columnStyle, className: columnClassName, items = [] }, i) => {
                  const styleObject = { ...columnStyle } as React.CSSProperties;
                  if (shouldWrap) {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    styleObject.flex = `0 0 ${100 / (maxColumnsPerRow! + 1) + 0.1}%`;
                  }
                  return (
                    <Column
                      key={i}
                      prefixCls={prefixCls}
                      title={title}
                      icon={icon}
                      items={items}
                      style={styleObject}
                      className={columnClassName}
                    />
                  );
                })}
              </section>
            )}
          </Col>
        </Row>
      </section>
      {bottom && (
        <section className={`${prefixCls}-bottom`}>
          <Bottom prefixCls={prefixCls} items={bottom.items} title={bottom.title} />
        </section>
      )}
    </Footer>
  );
};

export default GlobalFooter;
